'use client';

import type { UpdatingDataCriteria, UpdatingDataValue } from '~/components/Profile/model';
import type { CriteriaChoiceUserType } from '~/model/CriteriaChoiceType';
import type { CriteriaType } from '~/model/CriteriaType';
import { useLocale } from 'next-intl';
import { retrieveTranslatedLabel } from '~/components/Interaction/Form/utils';
import { apiTypes } from '~/const/api';
import { AcceptLanguage } from '~/const/locale';
import { CriteriaDate } from './CriteriaDate';
import { CriteriaInteger } from './CriteriaInteger';
import { CriteriaSelect } from './CriteriaSelect';

export const Criteria = ({
  criteria,
  userCriteria,
  updatingUserValue,
  handleChange,
  sportId,
  required,
  helperText,
  noLabel,
  loading = false,
}: {
  criteria: CriteriaType;
  userCriteria: CriteriaChoiceUserType;
  updatingUserValue: UpdatingDataValue;
  handleChange: (obj: UpdatingDataCriteria) => void;
  sportId?: number;
  required?: boolean;
  helperText?: string;
  noLabel?: boolean;
  loading?: boolean;
}) => {
  const locale = useLocale();
  const userChoices = userCriteria?.choices;
  const type = criteria?.type;
  const isCriterionSelect
    = type === apiTypes.SELECT
      || type === apiTypes.CHECK
      || type === apiTypes.RADIO;

  return !loading
    ? (
        <>
          {type === apiTypes.INTEGER && (
            <CriteriaInteger
              criteria={criteria}
              userValue={userCriteria?.value_int}
              updatingUserValue={updatingUserValue}
              handleChange={handleChange}
              sportId={sportId}
              required={required}
              helperText={helperText}
              noLabel={noLabel}
            />
          )}

          {isCriterionSelect && (
            <CriteriaSelect
              criteria={criteria}
              userChoices={userChoices}
              updatingUserValue={updatingUserValue}
              handleChange={handleChange}
              sportId={sportId}
              required={required}
              helperText={helperText}
              noLabel={noLabel}
            />
          )}

          {type === apiTypes.DATE && (
            <CriteriaDate
              criteria={criteria}
              userCriteria={userCriteria}
              updatingUserValue={updatingUserValue}
              handleChange={handleChange}
              sportId={sportId}
              required={required}
              helperText={helperText}
              noLabel={noLabel}
            />
          )}
        </>
      )
    : (
        <div className="profile__field">
          <label className="vtmn-text-input_label">
            {retrieveTranslatedLabel(criteria, AcceptLanguage[locale])}
          </label>
          <span
            className="vtmn-skeleton vtmn-skeleton_line"
            style={{ width: '100%', height: '44px' }}
          />
        </div>
      );
};
